
/* 
Main JS
*/

(function($) {

  $('.bch-menu-search').click(function() {
        $(".search-bar").toggleClass("search-open");
        //$(".search-icon").toggleClass("search-icon-open");
  })

})( jQuery );

// Initiate aos animations
  AOS.init();


  (function($) {
    $('.news-carousel').owlCarousel({
          stagePadding: 100,
          loop:true,
          margin:10,
          autoplay:true,
          autoplayTimeout:4000,
          autoplayHoverPause:true,
           nav:true,
           dots:true,
          responsive:{
              0:{
                  items:1,
                  stagePadding: 25
              },
              600:{
                  items:2,
                  stagePadding: 25,
                  margin:5
              },
              1000:{
                  items:3,
                  margin:5
              }
          }
      })
  })( jQuery );



  (function($) {
    $('.slider-carousel').owlCarousel({
          loop:true,
          items:1,
          nav:true,
          dots:true,
          margin: 10,
          autoplay:true,
          autoplayTimeout:4000,
          autoplayHoverPause:true
       
                
      })
  })( jQuery );

(function($) {
    $('#testimonialSlider').owlCarousel({
          loop:true,
          items:1,
          nav:false,
          dots:true,
          margin: 10,
          autoplay:true,
          autoplayTimeout:5000,
          autoplayHoverPause:true       
    })
})( jQuery );



